const ROLES = {
  ADMIN: "admin",
  COMMERCIAL: "commercial",
  PRESCRIBER: "prescriber",
  PATIENT: "patient",
  DIRECTOR: "director",
  SUPERVISOR: "supervisor",
  RPP: "rpp",
};

export default ROLES;
